<template>
    <div class="modal-mask">
        <div class="modal-wrapper">
            <div class="modal-container">
                <div class="modal-header">
                    <div class="discardContainer">
                        <div style="display: flex; justify-content: space-between">
                            <div class="title">Please Select Campaign Class</div>
                            <img alt="img" class="pointer" @click="onCloseClick" src="../assets/crossIcon.svg" />
                        </div>
                        <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 24px;">
                            <input :disabled="!enableCreateCampaign" v-model="selectedCampaignClass" value="Sponsored" type="radio">
                            <label class="reportLabel" >{{"Sponsored"}}</label>
                        </div>
                        <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 24px;">
                            <input v-model="selectedCampaignClass" value="Privilege" type="radio">
                            <label class="reportLabel" >{{"Privilege"}}</label>
                        </div>
                        <div class="btns"> 
                            <div class="cancelBtn" @click="onCloseClick">Cancel</div>
                            <div
                                :class="`${!enableCreateCampaign && selectedCampaignClass === 'Sponsored' ? 'disabledCreateBtn' : ''} discardBtn`"
                                @click="onContinueClick"
                            >
                                Continue
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
    export default {
        name: 'CampaignClassDialog',
        props: {
            enableCreateCampaign: Boolean,
         },
         data() {
            return {
                selectedCampaignClass: "Sponsored"
            }
         },
        methods: {
            ...mapActions(['setCampaignClass']),
            onCloseClick(){
                this.$emit('cancelClicked');
            }, 
            onContinueClick(){
                this.setCampaignClass(this.selectedCampaignClass);
                this.$emit('continueClicked');
            }
        }
    }
</script>

<style scoped>

    .discardContainer{
        max-width: 1189px;
        margin: 0 auto;
        text-align: center;
        padding: 16px 30px 30px;
        width: 308px;
        background: #FFFFFF;
        border-radius: 12px;
    }
    .title{
        font-weight: 700;
        font-size: 18px;
        line-height: 25px;
        text-align: center;
        color: #333333;
        margin: 24px 0 16px;
    }

    .btns{
        display: flex;
    }

    .cancelBtn{
        border: 1px solid #2E31BE;
        border-radius: 4px;
        padding: 12px 42px;
        font-weight: 700;
        font-size: 14px;
        line-height: 17px;
        color: #2E31BE;
        cursor: pointer;
        margin-right: 20px;
    }

    .discardBtn{
        background: #2E31BE;
        border-radius: 4px;
        padding: 12px 42px;
        font-weight: 700;
        font-size: 14px;
        line-height: 17px;
        text-align: center;
        color: #FFFFFF;
        cursor: pointer;
        width: 50px;
    }
    .pointer {
        cursor: pointer;
    }


    .modal-mask {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        display: table;
        transition: opacity 0.3s ease;
    }

    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;
    }
    .modal-container {
        width: 300px;
        margin: 0px auto;
        padding: 20px 30px;
        border-radius: 2px;
        transition: all 0.3s ease;
        font-family: Helvetica, Arial, sans-serif;
    }

    .modal-header h3 {
        margin-top: 0;
        color: #42b983;
    }

    .modal-body {
        margin: 20px 0;
    }
    .modal-default-button {
      float: right;
    }
    .modal-enter-from, .modal-leave-to {
        opacity: 0;
    }
    .modal-enter-active .modal-container,
    .modal-leave-active .modal-container {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }
    .disabledCreateBtn {
        opacity: 0.4;
        cursor: not-allowed;
        pointer-events: none;
    }
</style>